import { render, staticRenderFns } from "./DocumentApproval.vue?vue&type=template&id=da531fbe&scoped=true"
import script from "./DocumentApproval.vue?vue&type=script&lang=ts"
export * from "./DocumentApproval.vue?vue&type=script&lang=ts"
import style0 from "./DocumentApproval.vue?vue&type=style&index=0&id=da531fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da531fbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDialog,VImg})
